import {
  createSlice,
  createAsyncThunk,
  createSelector,
  current,
} from "@reduxjs/toolkit";
import api from "../../utils/api";
import {toast} from "react-toastify";

const WiseBerryAPIEnv = process.env.VITE_API_KEY;

export const getBuyers = createAsyncThunk(
  "buyers/getBuyers",
  async ({query, page, allocated, queryString}, {rejectWithValue}) => {
    try {
      const res = await api.get(
        `${WiseBerryAPIEnv}buyer?limit=10${
          queryString ? `&${queryString}` : ""
        }&active=1${query ? `&search_kw=${query}` : ""}&page=${page}${
          allocated ? `&allocated_to=${allocated}` : ""
        }`
      );

      return res.data;
    } catch (err) {
      // Error handling code
      return rejectWithValue(err);
    }
  }
);

export const getBuyerById = createAsyncThunk(
  "buyers/getBuyerById",
  async (id, {rejectWithValue}) => {
    try {
      const res = await api.get(`${WiseBerryAPIEnv}buyer/${id}`);

      return res.data.data;
    } catch (err) {
      // Error handling code
      return rejectWithValue(err);
    }
  }
);

export const SearchListings = createAsyncThunk(
  "buyer/SearchListings",
  async (query, {rejectWithValue}) => {
    try {
      const res = await api.get(
        `${WiseBerryAPIEnv}listing?limit=10&state=1&search_kw=${query}&direction=desc&sort_by=created_at`
      );
      return res.data.data;
    } catch (err) {
      if (err.response && err.response.status === 401) {
        toast.error("Please Login, Authorization Denied");
      }
      return rejectWithValue(err.message);
    }
  }
);

export const postAddNewBuyer = createAsyncThunk(
  "buyer/postAddNewBuyer",
  async (form, {rejectWithValue}) => {
    try {
      const response = await api.post(`${WiseBerryAPIEnv}buyer`, form, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      toast.success(response.data.message);
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getBuyerNote = createAsyncThunk(
  "buyer/getBuyerNote",
  async (id, {rejectWithValue}) => {
    try {
      const [notesRes, timelineRes] = await Promise.all([
        api.get(`${WiseBerryAPIEnv}buyer/notes?limit=1000&buyer=${id}`),
        api.get(`${WiseBerryAPIEnv}timeline?buyer=${id}&direction=past&type=5`),
      ]);

      // Now you have notesRes.data.data and timelineRes.data.data
      // You can combine them in whatever way you like
      return {
        notes: notesRes.data.data,
        timeline: timelineRes.data.data,
      };
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const addBuyerNote = createAsyncThunk(
  "buyer/addBuyerNote",
  async (data, {rejectWithValue}) => {
    const {form, type} = data;

    try {
      let res;
      if (type == "NA" || type === "BC") {
        res = await api.post(`${WiseBerryAPIEnv}history`, form, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
      } else {
        res = await api.post(`${WiseBerryAPIEnv}note`, form, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
      }

      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

// https://uat.wiseberryonline.com.au/api/v1/offer

export const postAddNewOffer = createAsyncThunk(
  "buyer/postAddNewOffer",
  async (form, {rejectWithValue}) => {
    try {
      const response = await api.post(`${WiseBerryAPIEnv}offer`, form, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      toast.success("Offer added successfully");

      return response.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
export const updateBuyer = createAsyncThunk(
  "buyer/updateBuyer",
  async (
    {contactId, buyerId, editedFormadata, priceFormData},
    {rejectWithValue}
  ) => {
    try {
      const requestOne = api.post(
        `${WiseBerryAPIEnv}contact/${contactId}`,
        editedFormadata,
        {
          headers: {"Content-Type": "multipart/form-data"},
        }
      );

      const requestTwo = requestOne.then((response) => {
        let obj = {
          buyer_linked_contacts: [response.data.data.id],
          _method: "PATCH",
        };

        return api.post(`${WiseBerryAPIEnv}buyer/${buyerId}`, obj, {
          headers: {"Content-Type": "application/json"},
        });
      });

      const requestThree = requestTwo.then(() => {
        return api.post(`${WiseBerryAPIEnv}buyer/${buyerId}`, priceFormData, {
          headers: {"Content-Type": "multipart/form-data"},
        });
      });

      const [responseOne, responseTwo, responseThere] = await Promise.all([
        requestOne,
        requestTwo,
        requestThree,
      ]);

      toast.success(responseTwo?.data.message);

      return responseTwo?.data.data;
    } catch (error) {
      if (!error.response) {
        throw new Error("Network response was not ok");
      }
      return rejectWithValue(error.response.data);
    }
  }
);

let initialState = {
  buyers: {},
  loadBuyers: false,
  buyerError: null,

  activeTab: "all",

  singleBuyer: {},
  loadSingleBuyer: false,
  singleBuyerError: null,

  searchResult: [],
  loadingSearchResult: false,
  searchResultError: null,

  newBuyer: {},
  loadingNewBuyer: false,
  newBuyerError: null,

  //   currentIndexSlice
  currentIndexSlice: 0,

  buyerNotes: [],
  loadingBuyerNotes: false,
  buyerNotesError: null,
  // toggle gen note button
  showGeneralNotes: false,

  // addNote
  addedNotes: {},
  loadingAddingNotes: false,
  addedNotesError: null,

  // Offer
  newOffer: {},
  loadingNewOffer: false,
  newOfferError: null,

  // Update Buyer
  updatedBuyer: {},
  loadingUpdatedBuyer: false,
  updatedBuyerError: null,
};

const buyersSlice = createSlice({
  name: "buyersSlice",
  initialState,
  reducers: {
    setActiveTab: (state, action) => {
      // Reducer to update the active tab
      state.activeTab = action.payload;
    },
    setCurrentIndexSlice: (state, action) => {
      state.currentIndexSlice = action.payload;
    },
    incrementIndex: (state) => {
      state.currentIndexSlice += 1;
    },
    decrementIndex: (state) => {
      if (state.currentIndexSlice > 0) {
        state.currentIndexSlice -= 1;
      }
    },
    setGeneralNotes: (state, action) => {
      state.showGeneralNotes = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getBuyers.pending, (state) => {
        state.loadBuyers = true;
      })
      .addCase(getBuyers.fulfilled, (state, action) => {
        if (action.payload.current_page === 1) {
          state.buyers = action.payload;
        } else {
          state.buyers.data = [...state.buyers.data, ...action.payload.data];
          state.buyers.current_page = action.payload.current_page;
          state.buyers.first_page_url = action.payload.first_page_url;
          state.buyers.next_page_url = action.payload.next_page_url;
          state.buyers.prev_page_url = action.payload.prev_page_url;
          state.buyers.from = action.payload.from;
          state.buyers.to = action.payload.to;
        }

        state.loadBuyers = false;
        state.buyerError = null;
      })
      .addCase(getBuyers.rejected, (state, action) => {
        state.loadBuyers = false;
        state.buyerError = action.payload;
        state.buyers = {};
      })

      .addCase(SearchListings.pending, (state) => {
        state.loadingSearchResult = true;
      })
      .addCase(SearchListings.fulfilled, (state, action) => {
        state.searchResult = action.payload;
        state.searchResultError = null;
        state.loadingSearchResult = false;
      })
      .addCase(SearchListings.rejected, (state, action) => {
        state.searchResult = null;
        state.searchResultError = action.payload;
        state.loadingSearchResult = false;
      })
      .addCase(postAddNewBuyer.pending, (state) => {
        state.loadingNewBuyer = true;
      })
      .addCase(postAddNewBuyer.fulfilled, (state, action) => {
        state.newBuyer = action.payload;
        state.newBuyerError = null;
        state.loadingNewBuyer = false;
      })
      .addCase(postAddNewBuyer.rejected, (state, action) => {
        state.newBuyer = null;
        state.newBuyerError = action.payload;
        state.loadingNewBuyer = false;
      })
      .addCase(getBuyerById.pending, (state) => {
        state.loadSingleBuyer = true;
      })
      .addCase(getBuyerById.fulfilled, (state, action) => {
        state.singleBuyer = action.payload;
        state.singleBuyerError = null;
        state.loadSingleBuyer = false;
      })
      .addCase(getBuyerById.rejected, (state, action) => {
        state.singleBuyer = null;
        state.singleBuyerError = action.payload;
        state.loadSingleBuyer = false;
      })
      .addCase(getBuyerNote.pending, (state) => {
        state.loadingBuyerNotes = true;
      })
      .addCase(getBuyerNote.fulfilled, (state, action) => {
        state.buyerNotes = action.payload;
        state.buyerNotesError = null;
        state.loadingBuyerNotes = false;
      })
      .addCase(getBuyerNote.rejected, (state, action) => {
        state.buyerNotes = null;
        state.buyerNotesError = action.payload;
        state.loadingBuyerNotes = false;
      })
      .addCase(addBuyerNote.pending, (state) => {
        state.loadingAddingNotes = true;
      })
      .addCase(addBuyerNote.fulfilled, (state, action) => {
        state.addedNotes = action.payload;
        state.addedNotesError = null;
        state.loadingAddingNotes = false;
      })
      .addCase(addBuyerNote.rejected, (state, action) => {
        state.addedNotes = null;
        state.addedNotesError = action.payload;
        state.loadingAddingNotes = false;
      })
      .addCase(postAddNewOffer.pending, (state) => {
        state.loadingNewOffer = true;
      })
      .addCase(postAddNewOffer.fulfilled, (state, action) => {
        state.newOffer = action.payload;
        state.newBuyerError = null;
        state.loadingNewOffer = false;
      })
      .addCase(postAddNewOffer.rejected, (state, action) => {
        state.newOffer = null;
        state.newBuyerError = action.payload;
        state.loadingNewOffer = false;
      })
      .addCase(updateBuyer.pending, (state) => {
        state.loadingUpdatedBuyer = true;
      })
      .addCase(updateBuyer.fulfilled, (state, action) => {
        state.updatedBuyer = action.payload;
        state.updatedBuyerError = null;
        state.loadingUpdatedBuyer = false;
      })
      .addCase(updateBuyer.rejected, (state, action) => {
        state.updatedBuyer = null;
        state.updatedBuyerError = action.payload;
        state.loadingUpdatedBuyer = false;
      });
  },
});

export const allNotes = (state) => {
  const buyerNotes = state?.buyerSlice?.buyerNotes || [];
  const combinedNotes = [
    ...(buyerNotes?.notes || []),
    ...(buyerNotes?.timeline || []),
  ];

  // Sort notes by pin status and date.
  combinedNotes.sort((a, b) => {
    // If a is pinned and b is not, a should come first.
    if (a.pinned && !b.pinned) {
      return -1;
    }

    // If b is pinned and a is not, b should come first.
    if (b.pinned && !a.pinned) {
      return 1;
    }

    // If neither or both are pinned, sort by date.
    const aDate = a.created_at || a.timeline_date;
    const bDate = b.created_at || b.timeline_date;

    return new Date(bDate) - new Date(aDate);
  });

  return combinedNotes;
};

export const noteType = (state) => state.buyerSlice.showGeneralNotes;
export const filteredBuyerNote = createSelector(
  [allNotes, noteType],
  (notes, type) => {
    switch (type) {
      case true:
        return notes;
      case false:
        return notes?.filter((note) => note?.type?.id !== 2);
      default:
        return notes;
    }
  }
);
export const {
  setActiveTab,
  setCurrentIndexSlice,
  incrementIndex,
  decrementIndex,
  setGeneralNotes,
} = buyersSlice.actions;

export default buyersSlice?.reducer;
